<template>
    <div class="visa_container">
        <div class="visa_top_title">
            Visa processing of &nbsp<span> {{visa.name}}</span>
        </div>
        <div class="visa_detail_container">
       <VisaProfile></VisaProfile>
       <VisaCard></VisaCard>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import VisaCard from '../components/VisaDetail/VisaCard';
import VisaProfile from '../components/VisaDetail/VisaProfile';
export default {
    components: {
        VisaCard,
        VisaProfile
    },
    computed: {
        ...mapGetters(['visa'])
    }
}
</script>




// WEBPACK FOOTER //
// src/pages/VisaDetail.vue